import Entity from './entity'
export default class QuestionTplUser extends Entity<number>{

	val1:string;
	val2:string;
	val3:string;
	val4:string;
	val5:string;
	val6:string;
	val7:string;

}